import { render, staticRenderFns } from "./AtomSwitchInput.vue?vue&type=template&id=4f8fd640&scoped=true&"
import script from "./AtomSwitchInput.vue?vue&type=script&lang=js&"
export * from "./AtomSwitchInput.vue?vue&type=script&lang=js&"
import style0 from "./AtomSwitchInput.vue?vue&type=style&index=0&id=4f8fd640&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8fd640",
  null
  
)

export default component.exports